const apiUrl = process.env.REACT_APP_API_URL;

function getBasicAuthHeader() {
  const username = process.env.REACT_APP_API_USERNAME;
  const password = process.env.REACT_APP_API_PASSWORD;
  const encodedCredentials = btoa(`${username}:${password}`);
  return `Basic ${encodedCredentials}`;
}

async function parseJsonSafely(response) {
  try {
    return await response.json();
  } catch (_) {
    return null;
  }
}

/**
 * Lists the organizations the user belongs to — source of truth for the
 * sidebar org switcher. Returns [{orgId, orgName, orgLogo, role, isOwner}].
 */
export async function fetchOrganizations(userId) {
  const response = await fetch(`${apiUrl}/api/user/${userId}/organizations`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
  });
  if (!response.ok) {
    throw new Error(`Organizations request failed: ${response.status}`);
  }
  return response.json();
}

/**
 * Persists the caller's active organization server-side. Body: { orgId }.
 */
export async function setActiveOrganization(userId, orgId) {
  const response = await fetch(`${apiUrl}/api/user/${userId}/active-organization`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Accept: '*/*',
      Authorization: getBasicAuthHeader(),
    },
    body: JSON.stringify({ orgId }),
  });
  if (!response.ok) {
    throw new Error(`Active organization update failed: ${response.status}`);
  }
  return parseJsonSafely(response);
}
